import { render, staticRenderFns } from "./PaymentDashboardMessage.vue?vue&type=template&id=5e979421&scoped=true&"
import script from "./PaymentDashboardMessage.vue?vue&type=script&lang=js&"
export * from "./PaymentDashboardMessage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDashboardMessage.vue?vue&type=style&index=0&id=5e979421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e979421",
  null
  
)

export default component.exports